'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _function = require('react-pure-render/function');

var _function2 = _interopRequireDefault(_function);

var _default = require('../img/common/icons/default.svg');

var _default2 = _interopRequireDefault(_default);

var _pink = require('../img/common/icons/pink.svg');

var _pink2 = _interopRequireDefault(_pink);

var _visited = require('../img/common/icons/visited.svg');

var _visited2 = _interopRequireDefault(_visited);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var K_WIDTH = 50;
var K_HEIGHT = 70;
var placeStyle = {
  // initially any map object has left top corner at lat lng coordinates
  // it's on you to set object origin to 0,0 coordinates
  position: 'absolute',
  width: K_WIDTH,
  height: K_HEIGHT,
  left: -K_WIDTH / 2,
  top: -K_HEIGHT,

  textAlign: 'center',
  color: '#3f51b5',
  fontSize: 16,
  fontWeight: 'bold',
  padding: 4,
  cursor: 'pointer',
  transform: 'scale(0.8)',
  transformOrigin: 'bottom',
  transition: 'transform 300ms',
  background: 'url(' + _default2.default + ') 0% 0% / cover'
};

var placeStyleHover = {
  transform: 'scale(1)',
  zIndex: 2
};

var placeStyleHighlighted = {
  background: 'url(' + _pink2.default + ') 0% 0% / cover',
  zIndex: 1
};

var placeStyleSelected = {
  background: 'url(' + _pink2.default + ') 0% 0% / cover',
  zIndex: 2
};

var placeStyleVisited = {
  background: 'url(' + _visited2.default + ') 0% 0% / cover'
};

var GoogleMapPin = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(GoogleMapPin, _Component);

  function GoogleMapPin() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, GoogleMapPin);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = GoogleMapPin.__proto__ || (0, _getPrototypeOf2.default)(GoogleMapPin)).call.apply(_ref, [this].concat(args))), _this), _this.shouldComponentUpdate = _function2.default, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(GoogleMapPin, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          clicked = _props.clicked,
          hover = _props.hover,
          visited = _props.visited,
          highlighted = _props.highlighted,
          popup = _props.popup,
          showPopup = _props.showPopup;

      // TODO: OMG this should be done with CSS class

      var style = (0, _extends3.default)({}, placeStyle);

      if (visited) {
        style = (0, _extends3.default)({}, style, placeStyleVisited);
      }

      if (highlighted) {
        style = (0, _extends3.default)({}, style, placeStyleHighlighted);
      }

      if (clicked) {
        style = (0, _extends3.default)({}, style, placeStyleSelected);
      }

      if (hover) {
        style = (0, _extends3.default)({}, style, placeStyleHover);
      }

      return _react2.default.createElement(
        'div',
        null,

        /* TODO: remove style here once design is finalized */
        clicked && showPopup ? _react2.default.createElement(
          'div',
          { className: 'hotel-in-map', style: {
              position: 'absolute',
              left: '-100px',
              top: '-320px',
              zIndex: '9999'
            }
          },
          showPopup ? popup : null
        ) : null,
        _react2.default.createElement('div', { className: 'hint hint--html hint--info hint--top', style: style })
      );
    }
  }]);
  return GoogleMapPin;
}(_react.Component), _class.propTypes = {
  // use hover from controllable
  hover: _react.PropTypes.bool,
  clicked: _react.PropTypes.bool,
  visited: _react.PropTypes.bool,
  highlighted: _react.PropTypes.bool,
  popup: _react.PropTypes.element,
  showPopup: _react.PropTypes.bool
}, _class.defaultProps = {}, _temp2);
exports.default = GoogleMapPin;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/GoogleMapPin.js
// module id = 1206
// module chunks = 0